import { useRef, useCallback } from 'react';
import {
  useMeetingSelector,
  useStableEvent
} from '../meeting/meetingProviderContextDef';
import { events } from '../utils';

const NOOP = () => {};

const selectMeeting = s => s.meeting;

/**
 *
 * @param {{
 *  onTranslationStateChanged?: Function,
 *  onTranslationLanguageChanged?: Function,
 *  onTranslationText?: Function,
 * }} options
 * @returns {{
 *  startTranslation: ( data: Object ) => Promise<void>
 *  changeTranslationLanguage: ( data: String ) => Promise<void>
 *  stopTranslation: () => Promise<void>
 * }}
 */
const useTranslation = ({
  onTranslationStateChanged = NOOP,
  onTranslationLanguageChanged = NOOP,
  onTranslationText = NOOP
} = {}) => {
  const meeting = useMeetingSelector(selectMeeting);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;

  useStableEvent(
    events['translation-state-changed'],
    onTranslationStateChanged
  );
  useStableEvent(
    events['translation-language-changed'],
    onTranslationLanguageChanged
  );
  useStableEvent(events['translation-text'], onTranslationText);

  const startTranslation = useCallback(async config => {
    if (!meetingRef.current) return;
    return await meetingRef.current.startTranslation(config);
  }, []);

  const changeTranslationLanguage = useCallback(async language => {
    if (!meetingRef.current) return;
    return await meetingRef.current.changeTranslationLanguage(language);
  }, []);

  const stopTranslation = useCallback(async () => {
    if (!meetingRef.current) return;
    return await meetingRef.current.stopTranslation();
  }, []);

  return { startTranslation, changeTranslationLanguage, stopTranslation };
};

export default useTranslation;
